<template>
  <div class="container">
    <vs-alert v-if="financialEvents[0].supplier_id != null" color="#F39200"
      :title="`El proveedor ${financialEvents[0].supplier_id} ha realizado los siguientes cambios en las últimas 72 horas`"
      active="true" class="mb-4">
      <ul style="list-style-type: disc;">
        <li v-for="event in financialEvents" :key="event.id">{{ event.description }}
          {{ timeAgoFormat(event.created_at) }}
        </li>
      </ul>
    </vs-alert>

    <div class="w-full button-options-container clearfix">

      <div class="float-left w-1/2">
        <!-- <vx-card> -->
        <h5 class="mb-0 bold primary">Variables de proyecto.</h5>
        <vs-divider class="mt-0 mb-1"></vs-divider>
        <div class="flex">
          <p class="mr-4 black"><span class="bold">Valor factura con IVA: </span>
            {{ costFormatNoCents(project.finance.total_cost_requested) }}</p>
          <p class="mr-4 black"><span class="bold">% Enganche: </span> {{ project.finance.deposit_request * 100 }}</p>
          <p class="mr-4 black"><span class="bold">Plazo: </span>
            {{ project.finance.term_requested != null ? project.finance.term_requested + " meses" : "--" }}</p>
        </div>
        <!-- <vs-button :disabled="!canSendOffer" size="small" color="warning" @click.stop="postLoanOffer">Enviar oferta a solicitante</vs-button> -->
        <!-- </vx-card> -->
      </div>

      <!--<vs-button
          :disabled="!isCreditRiskOrAdmin"
          color="success"
          class="small mr-2 float-right"
          @click="recalculateAmort()"
          v-if="project.status <= 6">
        Recalcular tabla de amort.
      </vs-button>-->
      <manual-amortization-table-button :projectId="project.id" />
      <vs-button color="success" class="small mr-2 float-right" @click="modalAmortizationTable()"
        v-if="project.finance">
        Ver tabla de amort.
      </vs-button>
    </div>

    <div class="flex mt-5">
      <div class="w-4/12 lg:w-5/12 pr-2">
        <vx-card title="Variables de proyecto" v-if="form !== null">
          <div class="grid grid-cols-2 gap-2">
            <vs-select class="w-full" v-model="form.financialProductId" disabled label="Producto financiero">
              <vs-select-item v-for="financialProduct in financialProducts" :text="financialProduct.short_name"
                :value="financialProduct.id"></vs-select-item>
            </vs-select>
            <vs-select class="w-full" @change="changeRiskModelVersionHandler"
              v-model="project.finance.risk_model_version" label="Versión modelo riesgo">
              <vs-select-item v-for="riskModelVersion in riskModelVersions" :value="riskModelVersion.id"
                :text="`${riskModelVersion.description} ${riskModelVersion.name}`"
                :key="riskModelVersion.id"></vs-select-item>
            </vs-select>
            <vs-select class="mt-2 w-full" @change="form.projectCategoryId = project.project_category_id"
              label="Categoría" v-model="project.project_category_id">
              <vs-select-item v-for="category in projectCategories" :text="category.name"
                :value="category.id"></vs-select-item>
            </vs-select>
            <vs-select class="mt-2 w-full" label="Tipo amortización" v-model="form.amortizationType">
              <vs-select-item text="Pagos variables" value="variable"></vs-select-item>
              <vs-select-item text="Pagos fijos" value="fixed"></vs-select-item>
            </vs-select>
            <vs-select class="mt-2 w-full" label="Financiamiento colectivo" :disabled="project.status >= 5"
              v-model="form.crowdfundingLoanType">
              <vs-select-item value="1" text="Préstamo Personal" />
              <vs-select-item value="2" text="Préstamo Empresarial" />
            </vs-select>
            <vs-select class="mt-2" label="Tipo de producto" :disabled="project.status >= 5" v-model="form.loanType">
              <vs-select-item value="1" text="Ecotecnologías" />
              <!--<vs-select-item value="2" text="Minado"/>
              <vs-select-item value="3" text="Capital de trabajo"/>-->
              <vs-select-item value="4" text="PYME" />
              <vs-select-item value="5" text="Personal" />
              <vs-select-item value="6" text="Automotriz" />
            </vs-select>
            <vs-select class="mt-2" label="Esquema de comisiones" v-model="form.spreadPortfolio">
              <vs-select-item value="0" text="Crédito verde" />
              <vs-select-item value="1" text="Crédito verde+" />
            </vs-select>
            <vs-select class="mt-2 hidden" label="Moneda" :disabled="disabledCriteria" v-model="form.currency">
              <vs-select-item value="mxn" text="MXN" />
              <vs-select-item value="usd" text="USD" />
            </vs-select>
            <template v-if="form.currency === 'usd'">
              <vs-input class="small mt-2 w-full" :disabled="true" v-model="totalCostMxn"
                label="Valor Factura en MXN con IVA"></vs-input>
              <vs-input @keyup="calculateTotalCost()" class="small mt-2 w-full" :disabled="disabledCriteria"
                v-model="form.totalCostUsd" label="Valor Factura en USD con IVA"></vs-input>
              <vs-input @keyup="calculateTotalCost()" class="small mt-2 w-full" :disabled="disabledCriteria"
                v-model="form.rateDof" label="Tipo de cambio (DOF)"></vs-input>
            </template>
            <template v-else>
              <vs-input name="totalCost" v-validate="'required'" class="small mt-2 w-full" :disabled="disabledCriteria"
                v-model="form.totalCost" label="Valor Factura con IVA"></vs-input>
            </template>
            <vs-input class="small mt-2 w-full" :disabled="disabledCriteria" v-model="form.deliveryTerm"
              label="Periodo de entrega"></vs-input>
            <vs-input name="depositPercentage" :danger="hasError('depositPercentage')" class="small mt-2 w-full"
              :disabled="disabledCriteria" v-model="form.depositPercentage"
              :danger-text="errorMessage('depositPercentage')" label="% Engache"></vs-input>
            <vs-select class="mt-2 w-full" v-model="form.term" :disabled="disabledCriteria" label="Plazo">
              <vs-select-item v-for="term in termRangeByFinancialProduct" :text="term" :value="term"></vs-select-item>
            </vs-select>
            <div class="mt-2 w-full">
              <label>Pago Entrega</label>
              <v-select class="vs-custom w-full" v-model.lazy="form.financedInterestPercentage"
                name="interestFinancedPercentage" placeholder="Seleccione el pago de entrega" v-validate="'required'"
                :options="interestFinancedPercentageOptions" :reduce="option => option.value" :clearable="false"
                :searchable="false">
                <template v-slot:option="option">
                  <span></span>
                  {{ option.name }} ({{ option.label }})
                </template>
              </v-select>
            </div>
            <vs-select class="mt-2 w-full" label="Calificación Final" v-model="form.qualification">
              <vs-select-item v-for="qualification in Object.keys(interestTable)" :key="qualification"
                :value="qualification" :text="qualification"></vs-select-item>
            </vs-select>
            <vs-select class="mt-2 w-full hidden" :disabled="disabledCriteria" v-model="form.paymentPeriodicity"
              label="Periodicidad">
              <vs-select-item :value="periodicity.enum" :text="periodicity.name"
                v-for="periodicity in periodicityOptions"></vs-select-item>
            </vs-select>
            <vs-input class="mt-2 w-full" name="capitalPaidAtTerm" :disabled="disabledCriteria"
              v-validate="'required|min_value:0|max_value:100'" :danger="hasError('capitalPaidAtTerm')"
              :danger-text="errorMessage('capitalPaidAtTerm')" v-model="form.capitalPaidAtTermPercentage"
              label="% Pago al vencimiento"></vs-input>
            <vs-input :disabled="disabledCriteria" class="mt-2 w-full hidden" name="totalCostSurplus"
              label="% Excedente factura" v-validate="'required|min_value:0|max_value:100'"
              :danger="hasError('totalCostSurplus')" :danger-text="errorMessage('totalCostSurplus')"
              v-model="form.totalCostSurplusPercentage"></vs-input>
            <template v-if="form.amortizationType === 'variable'">
              <vs-select class="mt-2 w-full" :disabled="disabledCriteria" v-model="form.amortizationPeriodicity"
                label="Periodicidad Amort.">
                <vs-select-item :value="periodicity.enum" :text="periodicity.name"
                  v-for="periodicity in periodicityOptions"></vs-select-item>
              </vs-select>
              <vs-select class="mt-2 w-full" :disabled="disabledCriteria" v-model="form.interestPeriodicity"
                label="Periodicidad Interés">
                <vs-select-item :value="periodicity.enum" :text="periodicity.name"
                  v-for="periodicity in periodicityOptions"></vs-select-item>
              </vs-select>
            </template>
          </div>
          <div class="flex gap-1 mt-3">
            <vs-button color="success" @click="updateEconomy()"
              :disabled="(simulation === null && disabledCriteria) || !isValidForm() || !isCreditRiskOrAdmin"
              class="small mr-2">
              Guardar
            </vs-button>
            <vs-button color="success"
              :disabled="simulating || disabledCriteria || !isValidForm() || !isCreditRiskOrAdmin" @click="simulate()"
              class="small mr-2">
              Simular
            </vs-button>
            <vs-button color="warning" :disabled="simulating" @click="downPaymentModal()" class="small mr-2">
              Calcular enganche
            </vs-button>
            <vs-button color="warning" v-if="project.status >= 3" :disabled="simulating" @click="getSimulationData()"
              class="small mr-2">
              Simulación de crédito
            </vs-button>
          </div>
        </vx-card>
      </div>
      <div class="flex-1 pr-2">
        <project-finance-form :loan-version="financialProductSelected.fees_set.loan_version" :amortization="amortTable"
          :finance="project.finance" :compare="simulation" />
        <!-- Garantías -->
        <vx-card class="mt-2">
          <loan-guarantees-control :projectId="project.id" :canEdit="true"></loan-guarantees-control>
        </vx-card>
        <vx-card title="Facturas de proyecto" class="mt-2">
          <invoices-control ref="invoices" :project_id="project.id" :isDisabled="true" />
        </vx-card>
      </div>
    </div>

    <vs-popup :active.sync="showDialog" title="Bitacora">
      <comments-view :project_id="project.id" v-on:sended="commentIsSended = true"></comments-view>
      <div class="mt-6">
        <vs-button color="dark" class="mr-2" @click="showDialog = false">Cancelar</vs-button>
        <vs-button @click="updateFinance()" :disabled="!commentIsSended">Guardar
        </vs-button>
      </div>
    </vs-popup>

    <vs-popup title="Seleccionar fecha de recálculo" v-model="amortizationTableModule.selection"
      :active.sync="amortizationTableModule.showDialog">
      <vs-input label="Fecha de primer pago" v-model="amortizationTableModule.selection" type="date"></vs-input>

      <vs-button class="mt-5 float-right" @click="executeRecalculation()">
        Recalcular
      </vs-button>
    </vs-popup>

    <vs-popup title="Tabla de amortización" :fullscreen="true" :active.sync="showAmortizationModal">
      <vs-table stripe :data="amortTableOrdered">
        <template slot="thead">
          <vs-th></vs-th>
          <vs-th>Fecha</vs-th>
          <vs-th>Pago mensual</vs-th>
          <vs-th>Pago en efectivo</vs-th>
          <vs-th>Pago Financiado</vs-th>
          <vs-th>Saldo inicial</vs-th>
          <vs-th>Amort. a capital</vs-th>
          <vs-th>Interés</vs-th>
          <vs-th>Comisión</vs-th>
          <vs-th>IVA</vs-th>
          <vs-th>Saldo final</vs-th>
        </template>
        <template slot-scope="{data}">
          <vs-tr v-for="amortRow in data" :class="{ 'text-danger': compareData(amortRow) }">
            <vs-td>{{ amortRow.number }}</vs-td>
            <vs-td>{{ amortRow.payment_date }}</vs-td>
            <vs-td align="right">{{ amortRow.payment | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.cash_payment | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.financed_payment | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.initial_debt | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.amortization | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.interest | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.client_comission | currency }}</vs-td>
            <vs-td align="right">{{ (amortRow.tax + amortRow.client_commission_tax) | currency }}</vs-td>
            <vs-td align="right">{{ amortRow.final_debt | currency }}</vs-td>
          </vs-tr>
        </template>
      </vs-table>

      <vs-button class="mt-4" color="danger"
        :href="`${StorageURL}/api/project/${project.id}/amortization/pdf/download?access_token=${user.access_token}`">
        Descargar PDF
      </vs-button>
    </vs-popup>

    <div class="modal fade" tabindex="-1" role="dialog" ref="down-payment-modal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Calcular enganche</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body align-self-center">
            <vs-input class="w-full" label="Pago inicial" v-model="initial_payment"></vs-input>

            <vs-table :data="[{}]">
              <vs-tr>
                <vs-th>% Enganche</vs-th>
                <vs-th>
                  <span class="copy">
                    {{ down_payment }}
                  </span>
                </vs-th>
              </vs-tr>
            </vs-table>
          </div>
          <div class="modal-footer">
            <vs-button @click="calculatedownPaymentPercentage()">
              Calcular enganche
            </vs-button>
          </div>
        </div>
      </div>
    </div>

    <detailed-simulator-pop-up :project="project" :rate="rate.dof" />

    <vs-popup v-if="loanInformation !== null" :active.sync="showLoanInformation" title="Información financiera">
      <h5>El solicitante cuenta actualmente con los siguientes créditos:</h5>
      <ul style="list-style-type: disc !important;">
        <li class="ml-6" :key="index" v-for="(loan, index) in loanInformation.balances">
          PID: <strong>{{ loan.project_id }}</strong>, saldo insoluto:
          <strong>{{ explicitMoneyFormat(loan.progress_balance) }}</strong>
        </li>
        <br>
        <li class="ml-6">
          PID <strong>{{ loanInformation.new_project_id }}</strong>, financiamiento nuevo solicitado (MXN):
          <strong>{{ explicitMoneyFormat(loanInformation.financed_amount) }}</strong>
        </li>
        <vs-divider></vs-divider>
        <li class="ml-4">Monto máximo a prestar por ley (MXN):
          <strong>{{ explicitMoneyFormat(loanInformation.max_loan_amount) }}</strong>
        </li>
        <li class="ml-4">Por lo tanto, el monto posible restante a prestar es de (MXN):
          <strong>{{ explicitMoneyFormat(loanInformation.loan_available) }}</strong>
        </li>
      </ul>
      <vs-divider></vs-divider>
      <vs-button class="mb-2 mt-4" size="sm" type="filled" color="warning" @click="showLoanInformation = false">
        Regresar
      </vs-button>
    </vs-popup>
  </div>
</template>
<script>
import ProjectFinanceForm from "../../../../components/project-details/ProjectFinanceForm";
import DetailedSimulatorPopUp from "../../../../components/project-details/DetailedSimulatorPopUp";
import { is } from '../../functions/userRoleBehavior'
import { mapState, mapMutations } from 'vuex';
import ProjectEconomySupplierValues from "../../../../components/project-details/ProjectEconomySupplierValues";
import ProjectImpact from "../../../../components/project-details/ProjectImpact";
import { ValidationBehavior } from '@components/project-details/ValidationBehavior';
import InvoicesControl from '@projects/InvoicesControl.vue'
import dateHelper from "@mixins/dateHelper";
import formatHelper from '@components/mixins/formatHelper';
import { humanDateFilter2 } from "@components/admin/filters/humanDateFilter";
import Datepicker from 'vuejs-datepicker';
import { es } from "vuejs-datepicker/dist/locale";
import _ from "lodash";
import LoanGuaranteesControl from '@components/projectsv2/loanGuarantees/LoanGuaranteesControl.vue';
import { Currency } from "@/models/Security/Currency";
import moment from "moment/moment";
let commentComponent = require("./message-log").default;
import ManualAmortizationTableButton from '@components/project-details/Economic/ManualAmortizationTableButton.vue';

export class FinanceForm {
  constructor(
    projectId,
    financialProductId,
    loanType,
    spreadPortfolio,
    currency,
    totalCost,
    totalCostUsd,
    rateDof,
    deliveryTerm,
    _depositPercentage,
    _financedInterestPercentage,
    term,
    qualification,
    paymentPeriodicity,
    _capitalPaidAtTermPercentage,
    _totalCostSurplusPercentage,
    crowdfundingLoanType,
    _amortizationPeriodicity,
    _interestPeriodicity,
    _projectCategoryId,
    _amortizationType
  ) {
    this.projectId = projectId;
    this.financialProductId = financialProductId;
    this.loanType = loanType;
    this.spreadPortfolio = spreadPortfolio;
    this.currency = currency;
    this.totalCost = totalCost.toFixed(2);
    this.totalCostUsd = totalCostUsd === null ? '0.00' : totalCostUsd.toFixed(2);
    this.rateDof = rateDof;
    this.deliveryTerm = deliveryTerm;
    this._depositPercentage = _depositPercentage;
    this._financedInterestPercentage = _financedInterestPercentage;
    this.term = term;
    this.qualification = qualification;
    this.paymentPeriodicity = paymentPeriodicity;
    this._capitalPaidAtTermPercentage = _capitalPaidAtTermPercentage || 0;
    this._totalCostSurplusPercentage = _totalCostSurplusPercentage || 0;
    this.crowdfundingLoanType = crowdfundingLoanType;
    this.amortizationPeriodicity = _amortizationPeriodicity || null;
    this.interestPeriodicity = _interestPeriodicity || null;
    this.projectCategoryId = _projectCategoryId;
    this.amortizationType = _amortizationType;
  }

  get depositPercentage() {
    return this.toInt(this._depositPercentage);
  }

  set depositPercentage(val) {
    this._depositPercentage = this.toDecimal(val);
  }

  get capitalPaidAtTermPercentage() {
    return this.toInt(this._capitalPaidAtTermPercentage);
  }

  set capitalPaidAtTermPercentage(val) {
    this._capitalPaidAtTermPercentage = this.toDecimal(val);
  }

  get financedInterestPercentage() {
    return this._financedInterestPercentage;
  }

  set financedInterestPercentage(val) {
    this._financedInterestPercentage = val;
  }

  get totalCostSurplusPercentage() {
    return this.toInt(this._totalCostSurplusPercentage);
  }

  set totalCostSurplusPercentage(val) {
    this._totalCostSurplusPercentage = this.toDecimal(val);
  }

  changeDeliveryTerm(val) {
    this.deliveryTerm = val;
  }

  /**
   * @param {number} value
   */
  toInt(value) {
    return value * 100;
  }

  /**
   * @param {number} value
   */
  toDecimal(value) {
    return value / 100;
  }

  get totalCostFloat() {
    return this.currencyToFloat(this.totalCost)
  }

  get totalCostUsdFloat() {
    return this.currencyToFloat(this.totalCostUsd)
  }

  toRequest() {
    return {
      finance_product_id: this.financialProductId,
      loan_id: this.projectId,
      currency: this.currency,
      rate: this.rateDof,
      financed_interest_percentage: parseFloat(this._financedInterestPercentage),
      total_cost: this.currencyToFloat(this.totalCost),
      total_cost_usd: this.currency === 'usd' ? this.currencyToFloat(this.totalCostUsd) : null,
      delivery_term: this.deliveryTerm,
      deposit_percentage: this._depositPercentage,
      term: this.term,
      qualification: this.qualification,
      loan_type: this.loanType,
      surplus_percentage: this._totalCostSurplusPercentage,
      capital_paid_at_term: this._capitalPaidAtTermPercentage,
      payment_periodicity: this.paymentPeriodicity,
      spread_portfolio: this.spreadPortfolio,
      crowdfunding_loan_type: this.crowdfundingLoanType,
      amortization_periodicity: this.amortizationPeriodicity,
      interest_periodicity: this.interestPeriodicity,
      project_category_id: this.projectCategoryId,
      amortization_type: this.amortizationType
    }
  }

  calculateTotalCostUsd() {
    this.totalCost = parseFloat((this.totalCostUsdFloat * this.rateDof).toFixed(2));
  }

  currencyToFloat(currency) {
    if (typeof currency !== "string") {
      return currency;
    }
    return parseFloat(currency.replace("$", "").replace(",", ""))
  }
}

export default {
  mixins: [dateHelper, formatHelper],
  data: () => ({
    form: {
      financialProductId: 5
    },
    es,
    payment_date: moment().subtract(59, 'days').format(),
    riskModelVersions: [],
    projectCategories: [],
    financialProducts: [],
    vMoneyFormat: {
      decimal: '.',
      thousands: ',',
      prefix: '$',
      suffix: '',
      precision: 2,
      masked: false
    },
    rate: {
      dof: 0,
      fix: 0
    },
    showAmortizationModal: false,
    periodicityOptions: [],
    termAvailable: [6, 12, 18, 24, 30, 36, 42, 48, 54, 60],
    interestFinancedPercentageOptions: [
      { value: 0, name: 'Pago entrega completo', label: '0%' },
      { value: 0.25, name: 'Pago entrega medio', label: '25%' },
      { value: 0.50, name: 'Pago entrega bajo', label: '50%' },
      { value: 0.75, name: 'Pago entrega muy bajo', label: '75%' }
    ],
    amortizationTableModule: {
      showDialog: false,
      firstPaymentDateFromAT: null,
      firstPaymentDateSystem: null,
      firstPaymentDateProjectFinance: null,
      selection: undefined,
      ready: false,
      isProcessing: false
    },
    admon_comission_adjust: 0,
    commentIsSended: false,
    simulation: null,
    showDialog: false,
    interestTable: {},
    amortTable: [],
    simulating: false,
    need_down_payment: false,
    down_payment: 0.0,
    initial_payment: 0.0,
    isDSActive: false,
    financialEvents: [
      {
        supplier_id: null
      }
    ],
    showLoanInformation: false
    , loanInformation: null
  }),
  computed: {
    financialProductSelected() {
      return this.financialProducts.find(fp => fp.id === this.form.financialProductId);
    },
    projectCategorySelected() {
      let projectCategories = this.projectCategories.filter((category) => {
        return category.id === this.project.project_category_id
      })
      if (projectCategories.length > 0) {
        return projectCategories[0]
      }
      return null;
    },
    totalCostMxn() {
      return Currency.format(this.form.totalCostUsdFloat * this.form.rateDof);
    },
    disabledCriteria() {
      return this.project.status > 3;
    },
    amortTableOrdered() {
      return _.sortBy(this.amortTable, (item) => item.number)
    },
    is_admin() {
      return is("admin", this.user.user_roles)
    },
    isCreditRiskOrAdmin() {
      return is("admin", this.user.user_roles) || is("credit_risk", this.user.user_roles);
    },
    ...mapState('projects', ['project']),
    ...mapState('auth', ['user']),
    canSimulate: function () {
      let cost = this.project.finance.total_cost;
      let time = this.project.finance.term;
      let percent = this.project.finance.deposit_percentage;
      let tasa = this.project.finance.annual_interest_percentage;

      if (cost != null && time != null && percent != null && tasa != null) {
        return true;
      }
    },
    currentTerm() {
      return this.project.finance.term != null ? this.project.finance.term : this.project.finance.term_requested
    },
    currentTotalCost() {
      return this.project.finance.term != null ? this.project.finance.total_cost : this.project.finance.total_cost_requested
    },
    termRangeByFinancialProduct() {
      if (this.financialProductSelected === undefined) {
        return this.termAvailable;
      }

      return this.termAvailable.filter((t) => {
        let min = this.financialProductSelected.financing_set.plazo_rango[0];
        let max = this.financialProductSelected.financing_set.plazo_rango[1];

        return t >= min && t <= max;
      })
    },
  },
  components: {
    Datepicker,
    ManualAmortizationTableButton,
    ProjectEconomySupplierValues,
    ProjectFinanceForm,
    DetailedSimulatorPopUp,
    'comments-view': commentComponent,
    InvoicesControl,
    ProjectImpact,
    LoanGuaranteesControl
  },
  beforeUpdate() {
    if (this.project.finance.qualification == null)
      this.project.finance.qualification = this.clasification;
  },
  async mounted() {
    const financialProductResponse = await axios.get('/api/loan/financial-products')
    this.financialProducts = financialProductResponse.data;

    const { data } = await axios.get('/api/interests');

    await this.fetchTerms();
    await this.fetchAmortizationTable();

    // default values
    if (this.project.finance.deposit_percentage === null) {
      this.project.finance.deposit_percentage = 0.0;
    }
    if (this.project.finance.financed_interests_percentage === null) {
      this.project.finance.financed_interests_percentage = 0.0;
    }
    if (this.project.finance.payment_periodicity === null) {
      this.project.finance.payment_periodicity = "monthly";
    }



    const periodicityResponse = await axios.get('api/finance/periodicity')
    this.periodicityOptions = periodicityResponse.data;
    this.interestTable = data;
    await this.getFinancialChanges();

    await this.getRiskModelVersions();
    const projectCategoryResp = await axios.get('/api/project-categories')
    this.projectCategories = projectCategoryResp.data;

    try {
      if (this.project.finance.currency === 'usd') {
        let exchangeRateResponse = await axios.get('/api/v1/exchange/rate');
        this.rate = exchangeRateResponse.data
      }
    } catch (e) {
      swal('Alerta', e.response.data.error, 'warning')
    }
    this.form = new FinanceForm(
      this.project.id,
      this.project.finance.financial_product_id,
      this.project.finance.loan_type,
      this.project.finance.spread_portfolio,
      this.project.finance.currency,
      parseFloat(this.currentTotalCost),
      parseFloat(this.project.finance.total_cost_usd),
      this.rate.dof,
      this.project.finance.delivery_term,
      this.project.finance.deposit_percentage,
      parseFloat(this.project.finance.financed_interests_percentage),
      this.currentTerm,
      this.project.finance.qualification,
      this.project.finance.payment_periodicity,
      this.project.finance.capital_paid_at_term_percentage,
      this.project.finance.total_cost_surplus_percentage,
      this.project.finance.crowdfunding_loan_type,
      this.project.finance.amortization_periodicity,
      this.project.finance.interest_periodicity,
      this.project.project_category_id,
      this.project.finance.amortization_type
    );
  },
  filters: {
    humanizeDate: humanDateFilter2,
    formatNumber(value) {
      let number = parseFloat(value);
      return number.toFixed(2)
    }
  },
  methods: {
    ...mapMutations('projects', ['setRelationship']),
    compareData(a) {
      const chargeDetails = a.amortization + a.interest + a.tax + a.client_comission + a.client_commission_tax;
      return chargeDetails.toFixed(2) != a.cash_payment;
    },
    async fetchAmortizationTable() {
      let res = await axios.get("/api/project/" + this.project.id + "/amortization")
      this.amortTable = res.data
    },
    async fetchTerms() {
      const { data } = await axios.get(`/api/backoffice/loan/term/${this.financialProductSelected.loan_type_id}`)
      this.termAvailable = data.data;
    },
    async getRiskModelVersions() {
      try {
        const { data } = await axios.get('/api/risk-model/versions');
        this.riskModelVersions = data;
      } catch (error) {
        console.log(error);
      }
    },
    async changeRiskModelVersionHandler() {
      this.$vs.loading();

      try {
        await axios.put(`/api/finance/${this.project.id}/risk-model-version`, {
          risk_model_version_id: this.project.finance.risk_model_version
        })
      } catch (e) {
        this.$vs.loading.close();
      } finally {
        this.$vs.loading.close();
      }
    },
    isValidForm() {
      return this.errors.count() === 0
    },
    hasError(inputName) {
      return this.errors.has(inputName)
    },
    errorMessage(inputName) {
      return this.errors.first(inputName)
    },
    calculateTotalCost() {
      this.form.calculateTotalCostUsd()
    },
    async changeDeliveryTem() {
      const { data } = await axios.post('/api/delivery-term/by-cost', {
        total_cost: this.form.totalCostFloat,
        term: this.project.finance.term
      })
      this.form.changeDeliveryTerm(data.delivery_term);
      this.project.finance.delivery_term = data.delivery_term;
    },
    async simulate() {
      let validator = ValidationBehavior.simulate(this.form)
      if (validator.valid) {
        this.simulating = true;

        try {
          const { data } = await axios.post(
            `/api/v1/projects/${this.project.id}/finance/simulate`,
            this.form.toRequest()
          );
          this.simulation = data;
          this.simulating = false;
        } catch (e) {
          swal("Ups!", "Hubo un error al realizar la simulación financiera.", 'error');
        }
      } else {
        swal("Atención", ValidationBehavior.objectToStringErrors(validator.errors), "warning")
      }
    },
    async updateEconomy() {
      if (this.project.status >= 4) {
        this.showDialog = true;
      } else {
        await this.updateFinance();
        //await this.recalculateAmort();
      }
    },
    async updateFinance() {
      this.showDialog = false;
      try {
        const { data } = await axios.put(`/api/v1/projects/${this.project.id}/finance`, this.form.toRequest());

        if (data.hasOwnProperty("balances")) {
          this.showLoanInformation = true;
          this.loanInformation = data;
        } else {
          // reset simulation
          this.simulation = null;
          this.setRelationship({
            keyProp: 'finance',
            value: data
          })
        }
      } catch (e) {
        console.error(e)
        swal('Ups!', 'Hubo un error al actualizar los datos financieros del proyecto.', 'error')
      }
    },
    async modalAmortizationTable() {
      try {
        await this.fetchAmortizationTable();
        this.showAmortizationModal = true;
      } catch (err) {
        swal("Upss!", "Hubo un error al cargar la tabla de amortización");
      }
    },
    async recalculateAmort() {
      try {
        this.amortizationTableModule.showDialog = true;
        this.amortizationTableModule.selection = await this.getFirstPaymentAmortizationTable()

        this.amortizationTableModule.ready = true;

      } catch (err) {
        swal("Ups!", AxiosErrorException(err), "error")
      }
    },
    async executeRecalculation() {
      try {
        this.amortizationTableModule.isProcessing = false
        await axios.post("/api/project/" + this.project.id + "/amortization/recalculate", {
          "first_payment_date": this.amortizationTableModule.selection,
          'finance_product_id': this.project.finance.financial_product_id
        })
        this.amortizationTableModule.showDialog = false;
        await this.modalAmortizationTable();
      } finally {
        this.amortizationTableModule.isProcessing = false
      }
    },
    async getFirstPaymentSystem() {
      try {
        const { data } = await axios.get(`/api/project/amortization/first-payment-date/calculate`);
        return data.first_payment_date;
      } catch (e) {
        throw e;
      }
    },
    async getFirstPaymentAmortizationTable() {
      try {
        const { data } = await axios.get("/api/project/" + this.project.id + "/amortization")
        if (data.length > 0) {
          return data[0].payment_date;
        }

        return null;
      } catch (e) {
        throw e;
      }
    },
    getFirstPaymentProjectFinance() {
      return this.project.finance.first_payment_date;
    },
    downPaymentModal() {
      this.initial_payment = 0.0;
      this.down_payment = 0.0;
      $(this.$refs["down-payment-modal"]).modal("show");
    },
    calculatedownPaymentPercentage() {
      const value = 1.16;
      let initialPayment = this.initial_payment;
      let dpOpenningComissionPercentage = 0.0200;
      let pfTotalCost = this.project.finance.total_cost;
      let down_payment = (initialPayment - (dpOpenningComissionPercentage * value * pfTotalCost)) / pfTotalCost;
      this.down_payment = down_payment.toFixed(13);
    },
    getSimulationData() {
      if (this.canSimulate && this.project.status >= 3) {
        this.$store.commit('TOGGLE_IS_DETAILED_SIMULATION_POPUP_ACTIVE', true)
      } else {
        this.errorNotif(
          "Información insuficiente",
          `No se puede realizar la simulación de crédito
             porque no se cuenta con la información suficiente.
             Verifique: Costo total de proyecto, Porcentaje de Enganche, Plazo y/o Tasa`
        )
      }
    },
    async getFinancialChanges() {
      try {
        let response = await axios.get(`/api/v1/project/${this.project.id}/getFinancialChanges`);
        if (response.data.length !== 0) {
          this.financialEvents = response.data;
        }
      } catch (err) {
        console.log("Error en la obtención de eventos en cambios financieros");
      }
    },
    // async postLoanOffer() {
    //   try {
    //     await axios.post(`/api/loan-onboarding/post/${this.project.id}/send-loan-offer`);
    //     swal("Oferta de crédito enviada", "La oferta de crédito ha sido enviada al cliente", "success");
    //   } catch (err) {
    //     swal("Error", "Hubo un error al enviar la oferta de crédito", "error");
    //   }
    // }
  }
}
</script>


<style>
.vs-select {
  margin-top: 3px;
}

.vs-th {
  text-transform: uppercase;
}

.modal-lg {
  max-width: 1200px;
}

.md-card {
  width: 100%;
}

.copy {
  color: #42a5f5;
  border-bottom: 1px dotted #42a5f5;
}

.copy.red {
  color: red;
  border-bottom: 1px dotted red;
}

.con-vs-alert {
  height: auto !important;
}

.vs-alert {
  padding-left: 1rem !important;
}
</style>
